module.exports = __webpack_public_path__ + "img/1688.953dd813.jpg";